<template>
  <div class="container">
    <div class="form-wrap">
      <common-search-form-wrapper :reset="resetSearch">
        <el-form size="mini" :model="searchInfo" label-width="64px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="班级名称:" prop="class">
                <el-select
                  v-model="searchInfo.class_id"
                  filterable
                  clearable
                  placeholder="请选择"
                  :filter-method="handleSearchClass"
                  @change="handleSearch"
                  @focus="handleSearchClass('')"
                >
                  <el-option
                    v-for="item in classList"
                    :key="item.class_id"
                    :label="item.name"
                    :value="item.class_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 暂时注释，看教务那边是否需要 -->
            <!-- <el-col :span="8">
              <el-form-item label="班级简称:" prop="class_sub">
                <el-select
                  v-model="searchInfo.class_sub"
                  filterable
                  clearable
                  placeholder="请选择"
                  :filter-method="handleSearchClassBySub"
                  @change="handleSearch"
                  @visible-change="handleSearchClassBySubVisible"
                  @clear="handleSearch"
                >
                  <el-option
                    v-for="item in SubClassList"
                    :key="item.class_id"
                    :label="item.sub_name"
                    :value="item.class_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="排课课程:" prop="course_id">
                <el-select
                  v-model="searchInfo.course_id"
                  filterable
                  clearable
                  placeholder="请选择"
                  :filter-method="handleSearchCourse"
                  @focus="handleSearchCourse('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in courseList"
                    :key="item.course_id"
                    :label="item.title"
                    :value="item.course_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="授课教师:" prop="teacher_id">
                <common-staff-pull-down
                  :originId.sync="searchInfo.teacher_id"
                  :defaultSelected.sync="searchInfo.teacher_list"
                  :multiple="true"
                  :jobIds="[1]"
                  @change="handleSearch"
                ></common-staff-pull-down>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上课学员:" prop="student_id">
                <el-select
                  v-model="searchInfo.student_id"
                  filterable
                  clearable
                  placeholder="请选择"
                  :filter-method="handleSearchStudent"
                  @focus="handleSearchStudent('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in studentList"
                    :key="item.student_id"
                    :label="item.name"
                    :value="item.student_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上课教室:" prop="classroom_id">
                <el-select
                  v-model="searchInfo.classroom_id"
                  filterable
                  clearable
                  multiple
                  placeholder="请选择"
                  :filter-method="handleSearchClassroom"
                  @focus="handleSearchClassroom('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in classroomList"
                    :key="item.classroom_id"
                    :label="item.name"
                    :value="item.classroom_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="授课模式:" prop="lesson_type">
                <el-radio-group
                  v-model="searchInfo.lesson_type"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">线下</el-radio-button>
                  <el-radio-button label="2">线上</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="点名状态:" prop="roll_call_status">
                <el-radio-group
                  v-model="searchInfo.roll_call_status"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="2">已点名</el-radio-button>
                  <el-radio-button label="1">未点名</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="班级类型:" prop="course_type">
                <el-radio-group
                  v-model="searchInfo.course_type"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">1vN</el-radio-button>
                  <el-radio-button label="2">1v1</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="班级人数:"
                prop="class_student_full"
                v-if="Number(searchInfo.course_type) === 1"
              >
                <el-radio-group
                  v-model="searchInfo.class_student_full"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">满班</el-radio-button>
                  <el-radio-button label="2">未满班</el-radio-button>
                </el-radio-group>
                <el-popover
                  placement="top"
                  popper-class="followuppopover"
                  trigger="hover"
                >
                  <p>班级人数筛选只显示 “1vN”班级的情况</p>
                  <i
                    class="el-icon-question"
                    slot="reference"
                    style="margin-left: 8px; color: #bebfc0"
                  ></i>
                </el-popover>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="到课状态:" prop="roll_call_student_status">
                <el-radio-group
                  v-model="searchInfo.roll_call_student_status"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">到课</el-radio-button>
                  <el-radio-button label="3">请假</el-radio-button>
                  <el-radio-button label="4">未到</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课次学员:" prop="student_type">
                <el-radio-group
                  v-model="searchInfo.student_type"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">临时</el-radio-button>
                  <el-radio-button label="5">体验</el-radio-button>
                  <!-- <el-radio-button label="2">调课</el-radio-button> -->
                  <el-radio-button label="3">补课</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课次练习:" prop="lesson_exercise">
                <el-radio-group
                  v-model="searchInfo.lesson_exercise"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">已发布</el-radio-button>
                  <el-radio-button label="2">未发布</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </common-search-form-wrapper>
    </div>
    <div class="week-change-wrap">
      <course-adjustment
        class="float-print-wrap"
        @courseAdjustment="renderSchedule"
      >
        <div class="float-print-button mwow-button success">快速调课</div>
      </course-adjustment>
      <date-switcher
        @switch="
          (arr) => {
            handleWeekChange(arr);
            if (visible) {
              renderSchedule();
            }
          }
        "
        @init="handleWeekChange"
        :immediate="false"
        rangeType="week"
        weekStartDay="1"
      ></date-switcher>
      <del-course-dialog
        @handleDelCourse="renderSchedule"
        class="float-print-wrap l1"
      >
        <div class="mwow-button success">删除课次</div>
      </del-course-dialog>
    </div>
    <div class="lc-title">
      共{{ dataTotal.total }}课次，已点名{{
        dataTotal.rollCallCount
      }}课次，未点名{{ dataTotal.notRollCallCount }}课次, 共{{
        dataTotal.rollcallStudentCount + dataTotal.notRollcallStudentCount || 0
      }}人次, 已点名{{ dataTotal.rollcallStudentCount }}人次,未点名{{
        dataTotal.notRollcallStudentCount
      }}人次
    </div>
    <div class="table" v-loading="loading">
      <div class="head">
        <div class="item"><span class="double">教师</span></div>
        <div
          @click="toDayView(weekTotal[0])"
          :class="today === weekTotal[0].full ? 'item active' : 'item'"
          :style="`${weekTotal[0].total ? 'cursor:pointer;' : ''}`"
        >
          <p class="title">周一 {{ weekTotal[0].date }}</p>
          <p class="total">
            共
            <span :class="`${weekTotal[0].total ? 'mwow-green' : ''}`">{{
              weekTotal[0].total
            }}</span>
            课次
          </p>
        </div>
        <div
          @click="toDayView(weekTotal[1])"
          :class="today === weekTotal[1].full ? 'item active' : 'item'"
          :style="`${weekTotal[1].total ? 'cursor:pointer;' : ''}`"
        >
          <p class="title">周二 {{ weekTotal[1].date }}</p>
          <p class="total">
            共
            <span :class="`${weekTotal[1].total ? 'mwow-green' : ''}`">{{
              weekTotal[1].total
            }}</span>
            课次
          </p>
        </div>
        <div
          @click="toDayView(weekTotal[2])"
          :class="today === weekTotal[2].full ? 'item active' : 'item'"
          :style="`${weekTotal[2].total ? 'cursor:pointer;' : ''}`"
        >
          <p class="title">周三 {{ weekTotal[2].date }}</p>
          <p class="total">
            共
            <span :class="`${weekTotal[2].total ? 'mwow-green' : ''}`">{{
              weekTotal[2].total
            }}</span>
            课次
          </p>
        </div>
        <div
          @click="toDayView(weekTotal[3])"
          :class="today === weekTotal[3].full ? 'item active' : 'item'"
          :style="`${weekTotal[3].total ? 'cursor:pointer;' : ''}`"
        >
          <p class="title">周四 {{ weekTotal[3].date }}</p>
          <p class="total">
            共
            <span :class="`${weekTotal[3].total ? 'mwow-green' : ''}`">{{
              weekTotal[3].total
            }}</span>
            课次
          </p>
        </div>
        <div
          @click="toDayView(weekTotal[4])"
          :class="today === weekTotal[4].full ? 'item active' : 'item'"
          :style="`${weekTotal[4].total ? 'cursor:pointer;' : ''}`"
        >
          <p class="title">周五 {{ weekTotal[4].date }}</p>
          <p class="total">
            共
            <span :class="`${weekTotal[4].total ? 'mwow-green' : ''}`">{{
              weekTotal[4].total
            }}</span>
            课次
          </p>
        </div>
        <div
          @click="toDayView(weekTotal[5])"
          :class="today === weekTotal[5].full ? 'item active' : 'item'"
          :style="`${weekTotal[5].total ? 'cursor:pointer;' : ''}`"
        >
          <p class="title">周六 {{ weekTotal[5].date }}</p>
          <p class="total">
            共
            <span :class="`${weekTotal[5].total ? 'mwow-green' : ''}`">{{
              weekTotal[5].total
            }}</span>
            课次
          </p>
        </div>
        <div
          @click="toDayView(weekTotal[6])"
          :class="today === weekTotal[6].full ? 'item active' : 'item'"
          :style="`${weekTotal[6].total ? 'cursor:pointer;' : ''}`"
        >
          <p class="title">周日 {{ weekTotal[6].date }}</p>
          <p class="total">
            共
            <span :class="`${weekTotal[6].total ? 'mwow-green' : ''}`">{{
              weekTotal[6].total
            }}</span>
            课次
          </p>
        </div>
      </div>
      <div class="row-wrap">
        <div class="row" v-for="(item, index) in schedule" :key="index">
          <div class="item">
            <p style="color: #5c5d5e">{{ item.teacher.name }}</p>
            <p class="mwow-green p6" @click="toWeekView(item.teacher)">
              预览空闲时间
            </p>
            <p style="color: #5c5d5e; margin-top: 5px">
              (合计
              <span :class="item.courseTotal > 0 ? 'mwow-green' : ''">{{
                item.courseTotal
              }}</span>
              课次)
            </p>
          </div>
          <div
            class="item"
            v-for="(day, dayi) in item.date_list"
            :key="dayi"
            @drop="handleDrop(day)"
            @dragover.prevent
          >
            <div>
              <div v-for="(it, idx) in day.lesson_list" :key="idx">
                <lesson-dialog :lid="it.lesson_id" @change="renderSchedule">
                  <div
                    class="lesson"
                    :style="`background-color:${
                      it.roll_call_status === 2 ? '#B8B8B8' : it.course.color
                    };`"
                    @dragstart="handleDrag(it)"
                    draggable
                    :class="it.in_holiday === 1 ? 'bias-bgc' : ''"
                  >
                    <div class="text">
                      <div class="tag-wrap">
                        <span
                          class="tag"
                          v-if="it.include_student_type.experience > 0"
                          >体</span
                        >
                        <span
                          class="tag"
                          v-if="it.include_student_type.temporary > 0"
                          >临</span
                        >
                        <span
                          class="tag"
                          v-if="it.include_student_type.repair > 0"
                          >补</span
                        >
                        <span class="tag" v-if="it.publish_homework === 1"
                          >练</span
                        >
                        <span v-if="it.roll_call_status === 2">
                          <span
                            class="tag"
                            v-if="it.include_roll_call_student_status.leave > 0"
                            >假</span
                          >
                          <span
                            class="tag"
                            v-if="
                              it.include_roll_call_student_status.absent > 0
                            "
                            >未</span
                          >
                          <span
                            class="tag"
                            v-if="
                              it.include_roll_call_student_status.leave === 0 &&
                              it.include_roll_call_student_status.absent === 0
                            "
                            >点</span
                          >
                        </span>
                      </div>
                      <p
                        :class="
                          it.include_student_type.experience > 0 ||
                          it.include_student_type.repair > 0 ||
                          it.include_student_type.temporary > 0 ||
                          it.include_roll_call_student_status.leave > 0 ||
                          it.include_roll_call_student_status.absent > 0 ||
                          it.roll_call_status === 2
                            ? 'time pad-top'
                            : 'time'
                        "
                      >
                        {{ it.start_time.slice(0, 5) }}-{{
                          it.end_time.slice(0, 5)
                        }}
                      </p>
                      <p v-if="it.classroom">
                        {{ it.classroom.name }}
                      </p>
                      <!-- <p>{{ it.class ? it.class.name : "-" }}</p> -->
                      <p>{{ it.class ? it.class.sub_name : it.class.name }}</p>
                      <p class="student-name">
                        <span>{{ it.studentStr }}</span>
                      </p>
                    </div>
                  </div>
                </lesson-dialog>
              </div>
            </div>
            <div class="teacher-resting-time" v-if="day.teacherDestDay">
              <p>休息</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="调课 - 课时修改提醒"
      :visible.sync="dragDialogVisible"
      destroy-on-close
      append-to-body
      width="465px"
      @close="renderSchedule"
    >
      <div class="drag-dialog-wrap">
        <div class="item">
          <p class="title">原课时</p>
          <div class="content">
            <p>{{ dragDialogData.date }}</p>
            <p>{{ dragDialogData.time }}</p>
            <p>{{ dragDialogData.teachers }}</p>
            <p>{{ dragDialogData.class }}</p>
          </div>
        </div>
        <i class="arrow el-icon-d-arrow-right"></i>
        <div class="item">
          <p class="title">修改后课时</p>
          <div class="content">
            <p class="mwow-green">{{ dragDialogData.newDate }}</p>
            <p class="mwow-green">{{ dragDialogData.time }}</p>
            <p>{{ dragDialogData.teachers }}</p>
            <p>{{ dragDialogData.class }}</p>
          </div>
        </div>
      </div>
      <div class="drag-dialog-btns">
        <div class="mwow-button-filled mini" @click="hideDragDialog">取消</div>
        <div class="mwow-button-filled success mini" @click="handleDragSubmit">
          确定
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from "@/utils/bus";
import dateSwitcher from "@/components/dateSwitcher.vue";
import { teachertimeTable, lessonDetail } from "@/api/schedule";
import { dateFormat } from "@/utils/timeFormat";
import lessonDialog from "./lessonDialog.vue";
import { editLessonTime } from "@/api/lesson";
import { classroomSelectListApi } from "@/api/classRoom";
import {
  getSelectClassList,
  getSelectCourseList,
  searchStudent,
} from "@/api/globalSearch";
import { mixin } from "@/mixin/tabPageInfoMixin";
import delCourseDialog from "@/components/delCourseDialog.vue";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import courseAdjustment from "@/components/courseAdjustment.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  name: "storeSchedule",
  props: ["visible"],
  components: {
    dateSwitcher,
    lessonDialog,
    delCourseDialog,
    courseAdjustment,
    commonStaffPullDown,
    commonSearchFormWrapper,
  },
  mixins: [mixin],
  data() {
    return {
      courseClass: [], // 班级排课信息
      classList: [],
      SubClassList: [],
      courseList: [],
      studentList: [],
      classroomList: [],
      searchInfo: {
        sub_name: "",
        lesson_type: "-1",
        roll_call_status: "-1",
        course_type: "-1",
        class_student_full: "-1",
        student_type: "-1",
        roll_call_student_status: "-1",
        lesson_exercise: "-1",
        classroom_id: [],
        teacher_id: [],
        teacher_list: [],
      },
      dataTotal: {
        total: 0,
        rollCallCount: 0,
        notRollCallCount: 0,
        rollcallStudentCount: 0,
        notRollcallStudentCount: 0,
      },
      schedule: [],
      loading: false,
      startTime: "",
      endTime: "",
      currentDialogData: {
        start_time: "",
        end_time: "",
        new_start_time: "",
        new_end_time: "",
        class: {},
      },
      dialogCache: {},
      moving: false,
      dragDialogVisible: false,
      dragDialogData: {},
      weekTotal: [
        {
          date: "",
          total: 0,
        },
        {
          date: "",
          total: 0,
        },
        {
          date: "",
          total: 0,
        },
        {
          date: "",
          total: 0,
        },
        {
          date: "",
          total: 0,
        },
        {
          date: "",
          total: 0,
        },
        {
          date: "",
          total: 0,
        },
      ],
      today: "",
    };
  },
  mounted() {
    this.mixinGetPageInfo("teacherTableSearch");
    eventBus.$on("schedule-range-change", () => {
      this.renderSchedule();
    });
    this.today = dateFormat("YYYY-mm-dd", new Date());
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.init();
    }
  },
  methods: {
    init() {
      if (this.searchInfo.className) {
        this.handleSearchClass(this.searchInfo.className);
      }
      if (this.searchInfo.courseName) {
        this.handleSearchCourse(this.searchInfo.courseName);
      }
      if (this.searchInfo.studentName) {
        this.handleSearchStudent(this.searchInfo.studentName);
      }
      if (this.searchInfo.classroomName) {
        this.handleSearchClassroom(this.searchInfo.classroomName);
      }
      this.renderSchedule();
    },
    resetSearch() {
      this.searchInfo = {
        lesson_type: "-1",
        roll_call_status: "-1",
        course_type: "-1",
        class_student_full: "-1",
        student_type: "-1",
        roll_call_student_status: "-1",
        lesson_exercise: "-1",
        classroom_id: [],
        teacher_id: [],
        teacher_list: [],
      };
      this.mixinSavePageInfo("teacherTableSearch");
      this.renderSchedule();
    },
    handleSearch() {
      this.renderSchedule();
      this.mixinSavePageInfo("teacherTableSearch");
    },
    handleSearchClassroom(v) {
      classroomSelectListApi({
        page: 1,
        page_size: 50,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.classroomList = res.data.list;
        }
      });
      this.searchInfo.classroomName = v;
    },
    handleSearchClass(v) {
      getSelectClassList({
        page: 1,
        page_size: 50,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.classList = res.data.list;
        }
      });
      this.searchInfo.className = v;
    },
    handleSearchClassBySub(v) {
      getSelectClassList({
        page: 1,
        page_size: 50,
        sub_name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            // 旧数据的班级没有 sub_name，默认使用 name 代替
            if (item.sub_name === "") {
              item.sub_name = item.name;
            }
          });
          this.SubClassList = res.data.list;
        }
      });
      this.searchInfo.class_sub = v;
    },
    handleSearchClassBySubVisible(rest) {
      if (rest) {
        this.handleSearchClassBySub("");
      }
    },
    handleSearchCourse(v) {
      getSelectCourseList({
        page: 1,
        page_size: 50,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseList = res.data.list;
        }
      });
      this.searchInfo.courseName = v;
    },
    handleSearchStudent(v) {
      searchStudent({
        page: 1,
        page_size: 50,
        key_word: v,
        status: [2],
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentList = res.data.list;
        }
      });
      this.searchInfo.studentName = v;
    },
    handleWeekChange(v) {
      this.startTime = dateFormat("YYYY-mm-dd", new Date(v[0]));
      this.endTime = dateFormat("YYYY-mm-dd", new Date(v[1]));
    },
    renderSchedule() {
      const params = {
        start_date: this.startTime,
        end_date: this.endTime,
      };
      if (this.searchInfo.course_id) {
        params.course_ids = [this.searchInfo.course_id];
      }
      if (this.searchInfo.class_id) {
        params.class_ids = [this.searchInfo.class_id];
      }
      // 使用简称过滤班级名称，再用班级名称查询表格数据
      if (this.searchInfo.class_sub) {
        params.class_ids = [this.searchInfo.class_sub];
      }
      if (this.searchInfo.teacher_id.length > 0) {
        params.teacher_ids = this.searchInfo.teacher_id;
      }
      if (this.searchInfo.student_id) {
        params.student_ids = [this.searchInfo.student_id];
      }
      if (Number(this.searchInfo.student_type) > 0) {
        params.student_type = Number(this.searchInfo.student_type);
      }
      if (Number(this.searchInfo.lesson_type) >= 0) {
        params.lesson_type = Number(this.searchInfo.lesson_type);
      }
      if (Number(this.searchInfo.roll_call_status) >= 0) {
        params.roll_call_status = Number(this.searchInfo.roll_call_status);
      }
      if (Number(this.searchInfo.course_type) >= 0) {
        params.course_type = Number(this.searchInfo.course_type);
        if (Number(this.searchInfo.course_type) === 1) {
          if (Number(this.searchInfo.class_student_full) >= 0) {
            params.class_student_full = Number(
              this.searchInfo.class_student_full
            );
          }
        }
      }
      if (Number(this.searchInfo.roll_call_student_status) >= 0) {
        params.roll_call_student_status = Number(
          this.searchInfo.roll_call_student_status
        );
      }
      if (
        this.searchInfo.classroom_id &&
        this.searchInfo.classroom_id.length > 0
      ) {
        params.classroom_ids = this.searchInfo.classroom_id;
      }
      if (Number(this.searchInfo.lesson_exercise) > 0) {
        params.publish_homework = Number(this.searchInfo.lesson_exercise);
      }
      this.loading = true;
      teachertimeTable(params)
        .then((res) => {
          this.loading = false;
          if (res.error_code === 0) {
            const arr = res.data.teacher_list;
            arr.map((i) => {
              // 每个老师一周课次统计
              i.courseTotal = 0;
              i.date_list.map((j) => {
                if (j.total > 0) {
                  i.courseTotal += j.total;
                }
                // 判断教师是否在休息日
                const weekDay = new Date(j.date).getDay();
                if (i.resting_time.indexOf(weekDay) !== -1) {
                  j.teacherDestDay = true;
                } else {
                  j.teacherDestDay = false;
                }
                j.lesson_list.map((k) => {
                  const tarr = [];
                  const studentNameList = [];
                  k.teacher_list.map((l) => {
                    tarr.push(l.name);
                  });
                  k.teacherStr = tarr.join(",");
                  if (k.student_list.length > 0) {
                    k.student_list.map((n) => {
                      studentNameList.push(n.student.name);
                    });
                  }
                  k.studentStr = studentNameList.join(",");
                });
              });
            });
            this.dataTotal = {
              total: res.data.total,
              rollCallCount: res.data.roll_call_count,
              notRollCallCount: res.data.not_roll_call_count,
              rollcallStudentCount: res.data.roll_call_student_count,
              notRollcallStudentCount: res.data.not_roll_call_student_count,
            };
            this.schedule = arr;
            this.updateTableHeader();
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    updateTableHeader() {
      const start = new Date(this.startTime).getTime();
      const week = {};
      for (let i = 0; i < 7; i++) {
        const cur = new Date(start + 24 * 60 * 60 * 1000 * i);
        week[dateFormat("YYYY-mm-dd", cur)] = {
          total: 0,
          date: `${cur.getMonth() + 1}月${cur.getDate()}日`,
        };
      }
      this.schedule.map((teacher) => {
        teacher.date_list.map((date) => {
          if (week[date.date]) {
            week[date.date].total = week[date.date].total + date.total;
          }
        });
      });
      const arr = [];
      for (const key in week) {
        arr.push({
          ...week[key],
          full: key,
        });
      }
      this.weekTotal = arr;
    },
    getLessonInfo(lesson) {
      const id = lesson.lesson_id;
      if (this.dialogCache[id]) {
        this.currentDialogData = this.dialogCache[id];
        this.courseClass = this.dialogCache[id].class;
      } else {
        lessonDetail({
          lesson_id: id,
        }).then((res) => {
          if (res.error_code === 0) {
            this.courseClass = res.data.class;
            const arr = [];
            const arr1 = [];
            const arr3 = [];
            const arr4 = [];
            if (lesson.roll_call_status === 2) {
              res.data.roll_call_student_list.map((item) => {
                if (item.student_status === 1) {
                  arr1.push(item.student.name);
                }
                if (item.student_status === 2) {
                  arr1.push(item.student.name);
                }
                if (item.student_status === 3) {
                  arr3.push(item.student.name);
                }
                if (item.student_status === 4) {
                  arr4.push(item.student.name);
                }
              });
            } else {
              res.data.student_list.map((item) => {
                arr.push(item.name);
              });
            }
            lesson.class.current_student_count =
              res.data.class.current_student_count;
            lesson.class.preset_student_count =
              res.data.class.preset_student_count;
            const result = {
              ...res.data,
              studentString: arr.join(","),
              studentString1: arr1.join(","),
              studentString3: arr3.join(","),
              studentString4: arr4.join(","),
            };
            this.currentDialogData = result;
            this.dialogCache[id] = result;
          }
        });
      }
    },
    toRollCall(rid, lid) {
      if (!rid) {
        // 未点名
        this.$router.push({
          name: "classTimeDetails",
          query: { id: String(lid) },
        });
      } else {
        // 已点名，去详情
        this.$router.push({
          name: "rollCallDetails",
          query: { id: String(rid) },
        });
      }
    },
    handleDrag(v) {
      this.moving = true;
      this.dragDialogData = {
        teachers: v.teacherStr,
        class: v.class.name,
        lesson_id: v.lesson_id,
        date: v.date,
        time: v.start_time.slice(0, 5) + "-" + v.end_time.slice(0, 5),
      };
    },
    handleDrop(v) {
      if (v.teacherDestDay) {
        return;
      }
      if (this.moving) {
        this.moving = false;
        if (this.dragDialogData.date !== v.date) {
          this.dragDialogData.newDate = v.date;
          this.showDragDialog();
        }
      }
    },
    showDragDialog() {
      this.dragDialogVisible = true;
    },
    hideDragDialog() {
      this.dragDialogVisible = false;
    },
    handleDragSubmit() {
      const params = { ...this.dragDialogData };
      editLessonTime({
        lesson_id: params.lesson_id,
        start_time: params.time.split("-")[0] + ":00",
        end_time: params.time.split("-")[1] + ":00",
        date: params.newDate,
      }).then((res) => {
        if (res.error_code === 0) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.hideDragDialog();
        } else {
          this.$message({
            type: "error",
            message: "修改失败：" + res.message,
          });
        }
        this.renderSchedule();
      });
    },
    toWeekView(teacher) {
      const obj = {
        num: 2,
        t_id: teacher.teacher_id,
        t_name: teacher.name,
        start_time: this.startTime,
        end_time: this.endTime,
      };
      eventBus.$emit("to-teacher-go-week-view", obj);
    },
    toDayView(obj) {
      if (obj.total) {
        eventBus.$emit("to-teacher-go-time-day-view", obj);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0px !important;
}
.form-wrap {
  position: relative;
  overflow: hidden;
  transition: height 300ms ease-in-out;
  padding-right: 20px;
}
.week-change-wrap {
  position: relative;
  margin-bottom: 24px;
  .float-print-wrap {
    position: absolute;
    bottom: 2px;
    left: 0;
    z-index: 100;
  }
  .l1 {
    left: 85px;
  }
}
.table {
  overflow: hidden;
  border: 1px solid #e1e5e9;
  position: relative;
  .head {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    display: flex;
    border-bottom: 1px solid #e1e5e9;
    background-color: #f2f6fa;
    overflow: hidden scroll;
    .item {
      flex: 1;
      font-size: 12px;
      color: #5c5d5e;
      text-align: center;
      line-height: 16px;
      height: 32px;
      padding: 4px 0;
      border-right: 1px solid #e1e5e9;
      .double {
        line-height: 32px;
      }
      &:last-child {
        border-right: 0;
      }
      &:first-child {
        // flex: none;
        width: 40px;
      }
      .title {
        font-size: 13px;
      }
      &.active {
        background-color: #f0fdfa;
        .title {
          color: #10d2ad;
        }
      }
    }
  }
  .row-wrap {
    height: 100%;
    overflow: hidden scroll;
    box-sizing: border-box;
    padding-top: 40px;

    .row {
      display: flex;
      border-bottom: 1px solid #e1e5e9;
      &:last-child {
        border-bottom: 0;
      }
      .item {
        display: flex;
        flex-direction: column;
        flex: 1;
        border-right: 1px solid #e1e5e9;
        padding: 5px;
        overflow: hidden;
        &:last-child {
          border-right: 0;
        }
        &:first-child {
          // flex: none;
          // width: 16px;
          padding: 20px 5px;
          // display: inline-flex;
          text-align: center;
          align-items: center;
          line-height: 16px;
          word-break: break-all;
        }
        .lesson {
          padding: 2px 0px 2px 8px;
          position: relative;
          cursor: pointer;
          text-align: left;
          p {
            color: #ffffff;
            font-size: 12px;
            line-height: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            &:first-child {
              padding-right: 30px;
            }
          }
          .tag-wrap {
            position: absolute;
            top: 0;
            left: 0;
            .tag {
              color: #fff;
              display: inline-block;
              vertical-align: top;
              font-size: 12px;
              line-height: 12px;
              padding: 4px 3px;
              background-color: #888888;
              border-bottom-left-radius: 20%;
              border-bottom-right-radius: 20%;
              transform: scale(0.8);
              transform-origin: right top;
            }
          }
        }
      }
    }
  }
}
.event-hover-dialog {
  margin: -12px;
  .content {
    padding: 12px;
    color: #5c5d5e;
    .p1 {
      font-size: 13px;
      line-height: 22px;
      span {
        vertical-align: middle;
      }
      img {
        vertical-align: middle;
        margin-left: 6px;
      }
    }
    .p2 {
      font-size: 12px;
      line-height: 22px;
      border-top: 1px solid #cbcbcb;
      padding-top: 8px;
      margin-top: 4px;
    }
  }
  .btns {
    display: flex;
    .btn {
      flex: 1;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
      &.green {
        color: #07d1aa;
        background: #f0fdfa;
      }
      &.blue {
        color: #32bdf3;
        background: #eaf8fd;
      }
      &.gray {
        color: #5c5d5e;
        background: #f1f1f1;
      }
    }
  }
}
.drag-dialog-wrap {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #5c5d5e;
  padding: 0 49px 20px 49px;
  .item {
    flex: 1;
    .title {
      margin-bottom: 12px;
    }
    .content {
      border-radius: 4px;
      padding: 12px;
      line-height: 24px;
      border: 1px solid #e7e8ea;
    }
  }
  .arrow {
    padding-top: 24px;
    font-size: 14px;
    margin: 0 12px;
  }
}
.drag-dialog-btns {
  text-align: right;
  .mwow-button-filled {
    margin-left: 10px;
  }
}
// /deep/.el-popper {
//   margin-top: -20px;
// }
/deep/.el-form {
  .el-form-item {
    margin-right: 38px;
    .el-select {
      width: 100%;
      .el-select__tags {
        width: 100%;
        display: flex;
        max-width: 161px;
        flex-wrap: nowrap;
        overflow-x: auto;
        &::-webkit-scrollbar {
          width: 4px;
          height: 1px;
        }
        &::-webkit-scrollbar-track {
          width: 4px;
          background: none;
        }
        &::-webkit-scrollbar-thumb {
          width: 4px;
          background: #d8d8d8;
          border-radius: 2px;
        }
      }
    }
  }
}
.p3 {
  font-size: 12px;
  line-height: 22px;
  border-top: 1px solid #cbcbcb;
  padding-top: 4px;
  margin-top: 4px;
}
.p5 {
  display: flex;
  font-size: 13px;
  span {
    flex: 1;
  }
}
.p6 {
  margin-top: 5px;
  cursor: pointer;
}
.curp {
  cursor: pointer;
  span {
    color: #07d1aa;
  }
}
.lc-title {
  margin-bottom: 12px;
  height: 28px;
  background: #fff7e9;
  border-radius: 4px;
  font-size: 12px;
  line-height: 28px;
  color: #5c5d5e;
  padding: 0 10px;
}
.pad-top {
  padding-top: 12px;
}
.student-name {
  padding: 0 !important;
  white-space: pre-wrap !important;
}
.teacher-resting-time {
  flex: 1;
  min-height: 77px;
  background-color: #f1f1f1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    color: #a0a0a0;
    font-size: 16px;
  }
}
</style>
